import { Button, CircularProgress, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { FC, useState, useEffect } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
import { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { ComponenteProjeto } from "../../types";

interface UploadComponentesVertivaisProperties {
    id: string;
    name: string;
    onUploaded: (componentes: any) => void
    onProgress: (progress: number | undefined) => void
}

const UploadComponentesVertivais: FC<UploadComponentesVertivaisProperties> = ({
    id,
    name,
    onUploaded,
    onProgress,
}) => {

    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);


    const uploadFile = (): void => {

        const form = new FormData();
        const name: string[] = selectedFile.name.split(".");
        const extension: string | undefined = name.pop();
        const element: any = document.getElementById(id);

        if (extension) {
            setLoading(true)

            form.append(`componentes_verticais.${extension}`, selectedFile, selectedFile.name);

            const request: IDataRequest = {
                url: "/projetos/componentes/adicionar",
                data: form,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent: any) => {
                    const _progress: number = (progressEvent.loaded * 100) / progressEvent.total
                    onProgress(_progress)
                }
            };
            apiNoLoading.post(request)
                .then((response: IDataResponse) => {
                    if (response.statusCode === STATUS_CODE.CREATED) {
                        const list: any = response?.data || []
                        onUploaded(list)
                    }
                })
                .catch((error: any) => {
                    //TO DO: Verificar tratamento de erro
                })
                .finally(() => {
                    if (element) {
                        element.value = '';
                    }
                    setLoading(false)
                });
        }



    }

    useEffect(() => {
        if (selectedFile) {
            uploadFile()
        }

    }, [selectedFile])

    return (
        <>

            <label htmlFor={id}>
                <Button
                    size="small"
                    variant="contained"
                    disableElevation
                    component="span"
                    disabled={loading}
                    fullWidth>
                    Carregar arquivo
                </Button>
            </label>


            <input
                accept="/*"
                id={id}
                type="file"
                name={name}
                style={{ display: "none" }}
                onChange={(e: any) => {
                    if (e.target.files !== null) {
                        setSelectedFile(e.target?.files[0])
                    }

                }}
            />
        </>
    );
}
export interface ComponentesVerticaisProperties {
    onLoading: (loading: boolean) => void;
    onChange: (componentes: ComponenteProjeto[]) => void;
    listaComponentes?: ComponenteProjeto[] | null;
}

const ComponentesVerticais: FC<ComponentesVerticaisProperties> = ({
    listaComponentes,
    onLoading,
    onChange
}) => {

    const [componentes, setComponentes] = useState<ComponenteProjeto[] | null>(listaComponentes || [])
    const [progress, setProgress] = useState<number | undefined>(undefined)
    // const [totalComponentes, setTotalComponentes] = useState<number>(0);

    useEffect(() => {
        setComponentes(listaComponentes || [])
    }, [listaComponentes]);

    const totais: number[] = (componentes?.map((c) => c.quantidade * c.valor_unitario) || [] as number[])
    const total = totais.length > 0 ? totais?.reduce((p: number, n: number) => p + n) : 0
    return <>
        <div className="row">
            <div className="X12">
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Código</TableCell>
                                <TableCell>Modelo</TableCell>
                                <TableCell align="right">Qtd.</TableCell>
                                <TableCell align="right">Valor unitário</TableCell>
                                <TableCell align="right">Valor unitário original</TableCell>
                                <TableCell align="right">Totais</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {componentes && componentes.length > 0
                                ? componentes.map((c: any, index: number) => {
                                    const valorTotalComponente: number = Number(c.quantidade * c.valor_unitario)
                                    return <>
                                        <TableRow key={`componentes-verticais-${c.componente_id}-${index}`}>
                                            <TableCell>{c.componente_id}</TableCell>
                                            <TableCell>{c.modelo}</TableCell>
                                            <TableCell align="right">{c.quantidade}</TableCell>
                                            <TableCell align="right">{Formater.toString(c.valor_unitario, TypeRecords.CURRENCY)}</TableCell>
                                            <TableCell align="right">{Formater.toString(c.valor_unitario_original, TypeRecords.CURRENCY)}</TableCell>
                                            <TableCell align="right">{Formater.toString(Number(valorTotalComponente), TypeRecords.CURRENCY)}</TableCell>
                                        </TableRow>
                                    </>
                                })
                                : progress !== undefined
                                    ? <>
                                        <TableRow>
                                            <TableCell colSpan={5} align="center"><LinearProgressBar progress={progress} color="secondary" /></TableCell>
                                        </TableRow>
                                    </>
                                    : ""
                            }
                            {total > 0 ? <>
                                <TableRow>
                                    <TableCell colSpan={6} align="right">
                                        {Formater.toString(Number(total), TypeRecords.CURRENCY)}
                                    </TableCell>
                                </TableRow>
                            </> : ""}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    </>
}

export { ComponentesVerticais }